exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-581a678c] table > tbody > tr > td:first-child {\n  max-width: 300px;\n}\n[data-v-581a678c] .custom-btn {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n[data-v-581a678c] table > tbody > tr > td:last-child {\n  width: 120px !important;\n}\n.custom-paginated-table .status-container[data-v-581a678c] {\n  padding: 5px;\n}\n.custom-paginated-table .invite-status[data-v-581a678c] {\n  text-transform: capitalize;\n  width: 100px;\n  display: block;\n  text-align: center;\n  padding: 5px 10px;\n}\n", ""]);

// exports
